import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { BaseHasTransactionDirective } from './base-has-transaction.directive';

@Directive({ selector: '[ifDoesntHaveSecurityTransaction]' })
export class IfDoesntHaveSecurityTransaction extends BaseHasTransactionDirective {
    @Input() set ifDoesntHaveSecurityTransaction(transaction: string) {
        this.parseTransaction(transaction);
    }

    constructor(
        protected _authService: AuthService,
        protected _elementRef: ElementRef,
        protected _renderer: Renderer2) {
        super(_authService, _elementRef, _renderer);
        // if the security transactions get updated, we need to re-evaluate
        this.transactionsUpdated$ = _authService.securityTransactionsUpdated;
    }

    private parseTransaction(securityTransaction: any) {
        this.updateView(securityTransaction);
    }

    condition(securityTransaction: string) {
        return !(this._authService.hasBusinessUnitAccess && this._authService.hasClaim(this._authService.transactionClaim, securityTransaction));
    }
}
